import { useChurchStore } from "features/churches";
import { useParams } from "react-router-dom";
import { useSendMessages } from "../api";
import { ChatPanel, DraftsPanel, MessageList } from "../components";
import { useStoredMessagesStore } from "../store";

export const Drafts = () => {
  const { id } = useParams();
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const storedMessages = useStoredMessagesStore(state => state.storedMessages);
  const storeMessages = useStoredMessagesStore(state => state.storeMessages);
  const draftsQuery = useSendMessages({
    churchId: selectedChurch?.id,
    filters: ["filters[is_draft]=1", "sort[created_at]=DESC"]
  });

  if (id) {
    storeMessages(draftsQuery?.data?.result);

    return (
      <>
        <MessageList title="Draft Messages" messages={storedMessages} />
        <ChatPanel />
      </>
    );
  }

  return <DraftsPanel />;
};
